import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import heroImgUrl from "@/assets/hero-garage.webp";
import heroImgMobileUrl from "@/assets/hero-garage-mobile.webp";
import { buildHomeSchemas } from "@/lib/seo";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Team } from "@/components/Team";
import { Services } from "@/components/Services";
import { Promos } from "@/components/Promos";
import { Contact, Footer } from "@/components/Contact";
import { DeferUntilIdle } from "@/components/DeferUntilIdle";

const AnimatedBackground = lazy(() =>
  import("@/components/AnimatedBackground").then((m) => ({ default: m.AnimatedBackground })),
);
import { FxsPromo } from "@/components/FxsPromo";
import { BlogHighlight } from "@/components/BlogHighlight";
import { Reviews, reviewSchemaScripts } from "@/components/Reviews";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Autószerelő és autószerviz Eger | LAKROSZ" },
      {
        name: "description",
        content:
          "Megbízható autószerviz Egerben 14+ év tapasztalattal. Fékjavítás, futómű, motorfelújítás, gumiszerelés, klíma, motorkerékpár szerviz. Időpontfoglalás: +36 30 478 7619.",
      },
      { property: "og:title", content: "Autószerelő és autószerviz Eger | LAKROSZ" },
      {
        property: "og:description",
        content:
          "Megbízható autószerviz Egerben 14+ év tapasztalattal. Fékjavítás, futómű, motorfelújítás, gumiszerelés, klíma, motorkerékpár szerviz. Időpontfoglalás: +36 30 478 7619.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://lakroszautoszerviz.com/" },
    ],
    links: [
      { rel: "canonical", href: "https://lakroszautoszerviz.com/" },
      { rel: "preload", as: "image", href: heroImgMobileUrl, media: "(max-width: 800px)", fetchPriority: "high" },
      { rel: "preload", as: "image", href: heroImgUrl, media: "(min-width: 801px)", fetchPriority: "high" },
    ],
    scripts: [...buildHomeSchemas(), ...reviewSchemaScripts()],
  }),
  component: Index,
});

function Index() {
  return (
    <main className="relative">
      <DeferUntilIdle delay={800}>
        <AnimatedBackground />
      </DeferUntilIdle>
      <Navbar />
      <Hero />
      <About />
      <Team />
      <Services />
      <Promos />
      <BlogHighlight />
      <Contact />
      <FxsPromo />
      <Reviews />
      <Footer />
    </main>
  );
}
